import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-access-denied',
  templateUrl: './auth-access-denied.component.html',
  styleUrls: ['./auth-access-denied.component.scss']
})
export class AuthAccessDeniedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
